export const CONSENT_KEY = "cookie_consent";
export const CONSENT_VERSION = 1;
export const CONSENT_MAX_AGE_MS = 365 * 24 * 3600 * 1000;
export const OPEN_SETTINGS_EVENT = "open-cookie-settings";
export const CONSENT_CHANGED_EVENT = "cookie-consent-changed";

export interface ConsentChoice {
  version: number;
  date: string;
  necessary: true;
  analytics: boolean;
  marketing: boolean;
}

/** Returns the stored choice if it is current (same version, younger than 12 months). */
export function readConsent(now = Date.now()): ConsentChoice | null {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null") as ConsentChoice | null;
    if (!c || c.version !== CONSENT_VERSION || !c.date) return null;
    if (now - new Date(c.date).getTime() >= CONSENT_MAX_AGE_MS) return null;
    return c;
  } catch {
    return null;
  }
}

export function hasMarketingConsent(): boolean {
  return !!readConsent()?.marketing;
}

export function saveConsent(analytics: boolean, marketing: boolean): ConsentChoice {
  const prevMarketing = hasMarketingConsent();
  const choice: ConsentChoice = { version: CONSENT_VERSION, date: new Date().toISOString(), necessary: true, analytics, marketing };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
  applyConsent(choice, prevMarketing);
  return choice;
}

export function applyConsent(c: ConsentChoice, prevMarketing = false) {
  const w = window as any;
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
  const m = c.marketing ? "granted" : "denied";
  if (typeof w.gtag === "function") {
    w.gtag("consent", "update", {
      ad_storage: m,
      ad_user_data: m,
      ad_personalization: m,
      analytics_storage: c.analytics ? "granted" : "denied",
    });
  }
  if (typeof w.fbq === "function") {
    if (c.marketing) {
      w.fbq("consent", "grant");
      if (!prevMarketing) w.fbq("track", "PageView");
    } else {
      w.fbq("consent", "revoke");
    }
  }
}
